import React from "react";
import { useNavigate } from "react-router-dom";
import { Paper, CardContent, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/styles";

export default function SmallCard(prop) {
  const theme = useTheme
  const navigate = useNavigate();
  return (
    <Paper elevation={3} sx={{ display: "flex", py: 1, px: 2, my: 1, cursor: "pointer" }} onClick={()=>navigate(prop.path)}>
      <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
        <CardContent sx={{ p: 0, pb: '0 !important' }}>
          <Typography
            color="primary"
            component="div"
            variant="body1"
            className="font-bold"
          >
            {prop.heading}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            component="div"
            className="font-bold"
          >
            {prop.caption}
          </Typography>
          <Typography
            color="primary"
            component="div"
            variant="h5"
            className="font-bold"
          >
            {prop.quantity}
          </Typography>
        </CardContent>
        {prop.imageFilename && <img src={prop.imageFilename} alt="icon" width={"100px"}/>}
      </Box>
    </Paper>
  );
}
